import React from 'react';
import { FormattedMessage } from 'react-intl';
import PayWithAppleButton from '../buttons/PayWithAppleButton';
import PayWithPayPalButton from '../buttons/PayWithPayPalButton';
import PayWithAmazonButton from '../buttons/PayWithAmazonButton';
import * as formStyles from '../styles/styles.module.scss';

interface Props {
  submitting: boolean;
  paypalHandler: any;
  applePayHandler: any;
  amazonPayHandler: any;
  showApplePay: boolean;
  showAmazonPay: boolean;
}

const ExternalPayForm = ({ submitting, paypalHandler, applePayHandler, amazonPayHandler, showApplePay, showAmazonPay }: Props) => {
  const checkoutWith = <FormattedMessage defaultMessage="Checkout with" />;

  let applePayDiv;
  if (showApplePay) {
    applePayDiv = (
      <div className={formStyles.inputItem}>
        <PayWithAppleButton text={checkoutWith} handler={applePayHandler} />
      </div>
    );
  }

  let amazonPayContent;
  if (showAmazonPay) {
    amazonPayContent = (
      <div className={formStyles.inputItem}>
        <PayWithAmazonButton text={checkoutWith} handler={amazonPayHandler} />
      </div>
    );
  }

  return (
    <div>
      <div className={formStyles.inputItem}>
        <PayWithPayPalButton text={checkoutWith} handler={paypalHandler} disabled={submitting} />
      </div>
      {applePayDiv}
      {amazonPayContent}
    </div>
  );
};

export default ExternalPayForm;
